import { Component, Inject } from "@angular/core";
import { NgOptimizedImage } from "@angular/common";
import { MAT_SNACK_BAR_DATA, MatSnackBarRef } from "@angular/material/snack-bar";

@Component({
    selector: "app-custom-alert",
    standalone: true,
    imports: [NgOptimizedImage],
    templateUrl: "./custom-alert.component.html",
    styleUrl: "./custom-alert.component.scss",
})
export class CustomAlertComponent {
    constructor(
        public snackBarRef: MatSnackBarRef<CustomAlertComponent>,
        @Inject(MAT_SNACK_BAR_DATA) public data: { message: string },
    ) {}
}
